import React from 'react'
import useSWRImmutable from 'swr/immutable'

import Loading from '../../components/layout/Loading'
import SelectInput from '../../components/form/SelectInput'
import { useI18N } from '../../../libraries/i18n/hook'
import { getAllIndustries } from '../../../api/industries'

type Props = {
  onChange: (values: { industryIds: string[] }) => void,
  values?: string[]
  label?: string
}
const IndustrySelectBox: React.FC<Props> = ({ onChange, values, label }) => {
  const { t } = useI18N()
  const { data, isLoading } = useSWRImmutable('industries', getAllIndustries)

  if(isLoading) return <Loading />

  const handleChange = (ids: string[]) => {
    onChange({ industryIds: ids })
  }

  const options = data?.map(({ name, id }) => ({ label: name, value: id.toString() }))
  if(!options) return null
  return (
    options && (
      <SelectInput
        isDisabled={options?.length === 0}
        value={options?.filter(industry => values?.includes(industry.value.toString()))}
        name='industryIds'
        label={label ?? t('common.industry')}
        onChange={handleChange}
        options={options}
        autoMinWidth
      />
    )
  )
}

export default IndustrySelectBox
